function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 106.72,
    style: {
      fill: "#FFB125"
    },
    width: 192.15,
    height: 358.44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.95,
    y: 106.72,
    style: {
      fill: "#FF901D"
    },
    width: 96.07,
    height: 358.44
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M200.338,284.787h-61.596v-97.529c0-2.833,2.297-5.13,5.13-5.13h51.335c2.833,0,5.13,2.297,5.13,5.13 L200.338,284.787L200.338,284.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF8A82"
    },
    d: "M277.515,123.852H71.308c-1.939,0-3.511-1.572-3.511-3.511v-19.855c0-1.939,1.572-3.511,3.511-3.511 h206.206c1.939,0,3.511,1.572,3.511,3.511v19.855C281.025,122.28,279.453,123.852,277.515,123.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D3A"
    },
    d: "M16.064,473.366h264.961V292.032H28.663c-6.958,0-12.598,5.64-12.598,12.598v168.736H16.064z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.95,
    y: 292.03,
    style: {
      fill: "#ED5729"
    },
    width: 96.07,
    height: 181.33
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#61AFF6"
    },
    points: "478.906,473.366 232.278,468.093 232.278,31.783 478.906,100.466 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#55A2F0"
    },
    points: "430.404,86.959 430.404,472.329 478.906,473.366 478.906,100.466 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AF8A82"
    },
    d: "M209.886,48.077l289.928,80.742c1.761,0.49,3.504-0.834,3.504-2.661v-20.507 c0-1.24-0.827-2.329-2.021-2.661L211.369,22.248c-1.761-0.49-3.504,0.834-3.504,2.661v20.507 C207.865,46.656,208.691,47.744,209.886,48.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB125"
    },
    d: "M446.208,355.885h-52.904c-2.308,0-4.18,1.871-4.18,4.18v113.302h61.264V360.064 C450.388,357.756,448.517,355.885,446.208,355.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M351.063,419.611h-82.899v-56.576c0-2.31,1.872-4.182,4.182-4.182h74.535 c2.31,0,4.182,1.872,4.182,4.182L351.063,419.611L351.063,419.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M346.881,358.853h-37.267v60.758h41.45v-56.576C351.063,360.725,349.19,358.853,346.881,358.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55A2F0"
    },
    d: "M353.158,411.701h-87.09c-4.368,0-7.91,3.541-7.91,7.91c0,4.369,3.541,7.91,7.91,7.91h87.09 c4.368,0,7.91-3.541,7.91-7.91C361.068,415.242,357.527,411.701,353.158,411.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M429,272.386H282.183v-94.342c0-4.307,3.492-7.799,7.799-7.799h131.219 c4.307,0,7.799,3.492,7.799,7.799L429,272.386L429,272.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M429,272.386h-73.408V170.245h65.609c4.307,0,7.799,3.492,7.799,7.799L429,272.386L429,272.386z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 266.74,
    style: {
      fill: "#AF8A82"
    },
    width: 390.03,
    height: 25.292
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.4,
    y: 266.74,
    style: {
      fill: "#927266"
    },
    width: 48.5,
    height: 25.292
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCDFED"
    },
    d: "M186.182,355.131H61.004c-2.235,0-4.047,1.812-4.047,4.047v25.512h133.272v-25.512 C190.229,356.943,188.417,355.131,186.182,355.131z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.957,
    y: 384.69,
    style: {
      fill: "#E6E6E6"
    },
    width: 133.27,
    height: 29.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.957,
    y: 414.25,
    style: {
      fill: "#CCDFED"
    },
    width: 133.27,
    height: 29.559
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.957,
    y: 443.81,
    style: {
      fill: "#E6E6E6"
    },
    width: 133.27,
    height: 29.559
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77DD00"
    },
    d: "M499.782,465.42H12.218C5.47,465.42,0,470.89,0,477.638l0,0c0,6.748,5.47,12.218,12.218,12.218 h487.565c6.748,0,12.218-5.47,12.218-12.218l0,0C512,470.89,506.53,465.42,499.782,465.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EC102"
    },
    d: "M511.939,476.431c-0.031-0.318-0.084-0.629-0.139-0.939c-0.013-0.071-0.019-0.144-0.033-0.214 c-1.1-5.618-6.045-9.858-11.985-9.858h-36.284v2.944c0,6.846-5.549,12.395-12.395,12.395H12.218c-5.139,0-9.528-3.176-11.333-7.669 C0.319,474.496,0,476.029,0,477.638l0,0c0,6.748,5.47,12.217,12.217,12.217h451.281h36.284c6.748,0,12.218-5.47,12.218-12.218l0,0 C512,477.23,511.979,476.828,511.939,476.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#927266"
    },
    d: "M503.156,104.726c-0.295-0.829-0.975-1.49-1.859-1.736L454.655,90v26.242l45.16,12.577 c1.457,0.406,2.887-0.44,3.342-1.777v-22.316H503.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901D"
    },
    d: "M435.537,404.845c-4.369,0-7.91,3.541-7.91,7.91v13.711c0,4.368,3.541,7.91,7.91,7.91 s7.91-3.541,7.91-7.91v-13.711C443.447,408.387,439.906,404.845,435.537,404.845z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.f86caaaf.svg";
export { ForwardRef as ReactComponent };